import { CursorTooltipStatus, LassoEditHandleType } from '../../../map/constants';

export enum CursorMode {
  DEFAULT = 'default',
  POINTER = 'pointer',
  DRAGGING = 'grabbing',
  DRAG = 'grab',
  LASSO = 'url(/cursor-lasso.svg) 7 24, crosshair',
  LASSO_CLOSE = 'url(/cursor-lasso-close.svg) 7 24, crosshair',
  MOVE = 'move',
}

export interface GetCursorParams {
  isDragging?: boolean;
  cursorTooltip?: CursorTooltipStatus | null;
  isDrawingLassoMode?: boolean;
  isLassoMode?: boolean;
  isHoveringWithinLasso?: boolean;
  hoveredEditHandleType?: (type: LassoEditHandleType) => boolean;
  isPicking?: boolean;
  canMoveStopsPermission?: boolean;
  isPanningMap?: boolean;
  hoveredMarker?: boolean;
  hoveredSuggestion?: boolean;
  isDrawMode?: boolean
}

const callIfDefined = (fn: Function | undefined, arg: any) => (fn ? fn(arg) : false);

export const getMapCursor = (params: GetCursorParams): string => {
  const {
    isDragging,
    cursorTooltip,
    isDrawingLassoMode,
    isLassoMode,
    isHoveringWithinLasso,
    hoveredEditHandleType,
    isPicking,
    canMoveStopsPermission,
    isPanningMap,
    hoveredMarker,
    hoveredSuggestion,
    isDrawMode,
  } = params;

  let cursor;

  switch (true) {
    case !!isDragging:
      cursor = CursorMode.DRAGGING;
      break;
    case (isPicking || hoveredSuggestion) && !hoveredMarker && !isLassoMode:
      cursor = CursorMode.POINTER;
      break;
    case cursorTooltip === CursorTooltipStatus.CLOSING_LASSO:
      cursor = CursorMode.LASSO_CLOSE;
      break;
    case callIfDefined(hoveredEditHandleType, LassoEditHandleType.INTERMEDIATE):
    case isDrawingLassoMode:
    case isDrawMode:
      cursor = CursorMode.LASSO;
      break;
    case isHoveringWithinLasso:
    case callIfDefined(hoveredEditHandleType, LassoEditHandleType.EXISTING) && isLassoMode:
    case !isPicking && hoveredMarker && canMoveStopsPermission:
      cursor = CursorMode.DRAG;
      break;
    case !!isPanningMap:
      cursor = CursorMode.MOVE;
      break;
    default:
      cursor = CursorMode.DEFAULT;
  }

  return cursor;
};
